import { FC } from 'react';
import { UserPicture } from '../helpers/user-picture';

export const UserProfile: FC<{
  email: string;
  displayName: string;
  children?: React.ReactNode;
}> = ({ email, displayName, children }) => {
  return (
    <div className="flex bg-skapa-neutral-2 px-6 py-8">
      <UserPicture email={email} displayName={displayName} size="large" />

      <div className="ml-6">
        <h1
          className="text-skapa-text-1 text-base font-bold leading-normal"
          data-testid="userFullName"
        >
          {displayName}
        </h1>
        <p
          className="text-skapa-text-3 text-sm font-normal leading-snug"
          data-testid="userEmail"
        >
          {email}
        </p>

        {children}
      </div>
    </div>
  );
};
